module.exports = __webpack_public_path__ + "media/icons/trash-alt-light-1e87f266.svg";